import {cloneDeep as _cloneDeep} from 'lodash';
import IncomeSourcesModel from "@/models/IncomeSourcesModel"
const IncomeSourcesModule = {
    namespaced: true,
    state: () => ({
        list: [],
        source: _cloneDeep(IncomeSourcesModel, true)
    }),
    getters: {
        getList (state) {
            return state.list
        },
        getSource (state) {
            return state.source
        },
    },
    mutations: {
        setList (state, payload) {
            state.list = payload
        },
        setSource (state, payload) {
            state.source = payload
        },
    },
    actions: {
        setList (context, payload) {
            context.commit('setList', payload);
        },
        setSource (context, payload) {
            context.commit('setSource', payload);
        },
    },

}

export default IncomeSourcesModule;
